import { type FC, type ReactNode } from "react";

/**
 * Shared overlay wrapper used by both steps of the Add Records wizard
 * (classify cards and the per-kind upload form). Renders the indigo border,
 * 4px gradient stripe (`.classify-overlay::before`), title, optional
 * subtitle, and a trailing slot for dismiss/change affordances.
 */
export const ClassifyOverlayShell: FC<{
  title: string;
  subtitle?: string;
  trailing?: ReactNode;
  children: ReactNode;
}> = ({ title, subtitle, trailing, children }) => (
  <div className="relative mb-4 rounded-xl border-2 border-indigo-500 bg-slate-50 p-7">
    {/* 4px gradient stripe at top edge — `.classify-overlay::before` */}
    <span
      aria-hidden="true"
      className="absolute top-0 right-0 left-0 h-1 rounded-t-xl bg-gradient-to-r from-indigo-500 to-violet-500"
    />
    <div className="mb-1 flex items-start justify-between gap-3">
      <div className="text-[17px] font-bold text-slate-900">{title}</div>
      {trailing}
    </div>
    {subtitle && (
      <div className="mb-4 text-[13px] text-slate-500">{subtitle}</div>
    )}
    {children}
  </div>
);
